import React, { FunctionComponent } from 'react';

import { Partner } from 'src/api/@generated/backend';

import { altiboxImageProps } from 'src/resources/images';

import { StyledDefaultImage, StyledImage } from './partner-logo.styled';

interface Props {
  partner?: Partner;
}

export const PartnerLogo: FunctionComponent<Props> = (props) => {
  const { partner } = props;

  if (!partner?.logoUrl) {
    return <StyledDefaultImage {...altiboxImageProps} />;
  }

  return <StyledImage src={partner.logoUrl} alt={partner.name} />;
};
